import {
  SiReact,
  SiJavascript,
  SiNodedotjs,
  SiExpress,
  SiMongodb,
  SiMysql,
  SiFigma,
  SiAmazonaws,
  SiFirebase,
  SiNetlify,
  SiFilezilla,
  SiGit,
  SiGithub,
  SiGitlab,
  SiPostman,
  SiRedis,
  SiNestjs,
  SiPhpmyadmin,
  SiStripe,
  SiRazorpay,
  SiGooglemaps,
  SiNextdotjs,
  SiPrisma,
  SiPostgresql,
} from "react-icons/si";
import { FiTerminal, FiCreditCard } from "react-icons/fi";

// Core skills with self-assessed proficiency (from the original portfolio data).
export const skills = [
  { name: "React Native", level: 95, icon: SiReact, category: "mobile" },
  { name: "JavaScript", level: 85, icon: SiJavascript, category: "mobile" },
  { name: "Node.js", level: 75, icon: SiNodedotjs, category: "backend" },
  { name: "Express", level: 80, icon: SiExpress, category: "backend" },
  { name: "MongoDB", level: 90, icon: SiMongodb, category: "database" },
  { name: "MySQL", level: 90, icon: SiMysql, category: "database" },
  { name: "UI/UX Design (Figma)", level: 85, icon: SiFigma, category: "design" },
];

export const skillCategories = [
  {
    id: "mobile",
    title: "Mobile & Frontend",
    description: "Cross-platform apps for Android and iOS from one JavaScript codebase.",
  },
  {
    id: "backend",
    title: "Backend",
    description: "Server-side features and REST APIs that the apps depend on.",
  },
  {
    id: "database",
    title: "Database",
    description: "Document and relational data modelling for production apps.",
  },
  {
    id: "design",
    title: "Design",
    description: "Wireframes, prototypes and UI design before code is written.",
  },
];

// Secondary tools and integrations (no proficiency score attached).
export const toolGroups = [
  {
    title: "Cloud & Deployment",
    items: [
      { name: "AWS", icon: SiAmazonaws },
      { name: "Firebase", icon: SiFirebase },
      { name: "Netlify", icon: SiNetlify },
      { name: "PuTTY", icon: FiTerminal },
      { name: "FileZilla", icon: SiFilezilla },
    ],
  },
  {
    title: "Version Control & APIs",
    items: [
      { name: "Git", icon: SiGit },
      { name: "GitHub", icon: SiGithub },
      { name: "GitLab", icon: SiGitlab },
      { name: "Postman", icon: SiPostman },
    ],
  },
  {
    title: "Data & Backend",
    items: [
      { name: "Next.js", icon: SiNextdotjs },
      { name: "Prisma", icon: SiPrisma },
      { name: "PostgreSQL", icon: SiPostgresql },
      { name: "Redis", icon: SiRedis },
      { name: "NestJS", icon: SiNestjs },
      { name: "phpMyAdmin", icon: SiPhpmyadmin },
    ],
  },
  {
    title: "Payments & Maps",
    items: [
      { name: "Stripe", icon: SiStripe },
      { name: "Razorpay", icon: SiRazorpay },
      { name: "CCAvenue", icon: FiCreditCard },
      { name: "Cashfree", icon: FiCreditCard },
      { name: "Google Maps", icon: SiGooglemaps },
    ],
  },
];
